module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.modelReady) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('h2', [_vm._v("预订限制设置")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "提前购买时间"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.aheadHoursType, 1)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 1
      }
    }
  }), _vm._v(" 用户任意时间购买均可使用")])]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.aheadHoursType, 2)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 2
      }
    }
  }), _vm._v("用户需提前")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 2,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadHours),
      callback: function($$v) {
        _vm.model.aheadHours = $$v
      },
      expression: "model.aheadHours"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("小时")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 2,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.model.minutes = $$v
      },
      expression: "model.minutes"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("\n                    分钟购买，方可使用\n                ")]), _vm._v(" "), (_vm.model.aheadHoursType === 2) ? _c('span', [_c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选择用户可随时购买使用，订单量可增加15%")])]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType3",
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.aheadHoursType, 3)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 3
      }
    }
  }), _vm._v(" 用户需在游玩")]), _vm._v(" "), _c('v-select', {
    staticClass: "mini-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadDays),
      callback: function($$v) {
        _vm.model.aheadDays = $$v
      },
      expression: "model.aheadDays"
    }
  }, _vm._l((8), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1 == 0 ? '当天' : '前' + (n - 1) + '天',
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_vm._v("的")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.hours),
      callback: function($$v) {
        _vm.model.hours = $$v
      },
      expression: "model.hours"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_vm._v("点")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.model.minutes = $$v
      },
      expression: "model.minutes"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("\n                    分前购买，方可使用\n                ")]), _vm._v(" "), (_vm.model.aheadHoursType === 3) ? _c('span', [_c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选择用户可随时购买使用，订单量可增加约30%")])]) : _vm._e()], 1), _vm._v(" "), (_vm.model.aheadHoursType === 3 && _vm.extra.isDirectDeal) ? _c('div', {
    style: ({
      color: _vm.model.needAheadSupplement ? 'inherit' : '#999'
    })
  }, [_c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needAheadSupplement),
      expression: "model.needAheadSupplement"
    }],
    attrs: {
      "id": "aheadSupplement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.needAheadSupplement) ? _vm._i(_vm.model.needAheadSupplement, null) > -1 : (_vm.model.needAheadSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.needAheadSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.needAheadSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.needAheadSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.needAheadSupplement = $$c
        }
      }
    }
  }), _vm._v(" 补充规则：用户购买后需等待")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.needAheadSupplement,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadHoursBeforeUse),
      callback: function($$v) {
        _vm.model.aheadHoursBeforeUse = $$v
      },
      expression: "model.aheadHoursBeforeUse"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_vm._v("小时")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.needAheadSupplement,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadMinutesBeforeUse),
      callback: function($$v) {
        _vm.model.aheadMinutesBeforeUse = $$v
      },
      expression: "model.aheadMinutesBeforeUse"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_vm._v("\n                    分钟方可使用\n                ")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "联系人信息"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "contractInfoType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoType),
      expression: "model.contractInfoType"
    }],
    attrs: {
      "id": "contractInfoType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.contractInfoType, 1)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        _vm.model.contractInfoType = 1
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "contractInfoType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoType),
      expression: "model.contractInfoType"
    }],
    attrs: {
      "id": "contractInfoType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.contractInfoType, 2)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        _vm.model.contractInfoType = 2
      }
    }
  }), _vm._v(" 需要")])]), _vm._v(" "), (_vm.model.contractInfoType === 2) ? _c('div', {
    staticClass: "extra-content-block",
    class: {
      'error-block-local': _vm.validateErrors.has('tab2', 'contractInfoRule')
    }
  }, [_c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要联系人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "CTMobile"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoRule.mobile),
      expression: "model.contractInfoRule.mobile"
    }],
    attrs: {
      "id": "CTMobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.contractInfoRule.mobile) ? _vm._i(_vm.model.contractInfoRule.mobile, null) > -1 : (_vm.model.contractInfoRule.mobile)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.contractInfoRule.mobile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.contractInfoRule.mobile = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.contractInfoRule.mobile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.contractInfoRule.mobile = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "CTName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoRule.name),
      expression: "model.contractInfoRule.name"
    }],
    attrs: {
      "id": "CTName",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.contractInfoRule.name) ? _vm._i(_vm.model.contractInfoRule.name, null) > -1 : (_vm.model.contractInfoRule.name)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.contractInfoRule.name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.contractInfoRule.name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.contractInfoRule.name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.contractInfoRule.name = $$c
        }
      }
    }
  }), _vm._v(" 姓名")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'contractInfoRule')),
      expression: "validateErrors.has('tab2','contractInfoRule')"
    }],
    staticClass: "notice",
    class: {
      'error-text-local': _vm.validateErrors.has('tab2', 'contractInfoRule')
    }
  }, [_vm._v("\n                    （至少选择一项）\n                ")])]) : _vm._e()]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "游玩人信息"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "visitorInfoType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.visitorInfoType, 1)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 1
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.visitorInfoType, 2)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 2
      }
    }
  }), _vm._v(" 只需要1位游玩人信息")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType3",
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.visitorInfoType, 3)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 3
      }
    }
  }), _vm._v(" 需要全部游玩人信息")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType4",
      "type": "radio"
    },
    domProps: {
      "value": 4,
      "checked": _vm._q(_vm.model.visitorInfoType, 4)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 4
      }
    }
  }), _vm._v(" 每"), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "min": 2,
      "disabled": _vm.model.visitorInfoType != 4
    },
    model: {
      value: (_vm.model.visitorInfoGroupSize),
      callback: function($$v) {
        _vm.model.visitorInfoGroupSize = $$v
      },
      expression: "model.visitorInfoGroupSize"
    }
  })], 1), _vm._v("位游玩人共用1个信息")])]), _vm._v(" "), (_vm.model.visitorInfoType !== 1) ? _c('div', {
    staticClass: "extra-content-block",
    class: {
      'error-block-local': _vm.validateErrors.has('tab2', 'visitorInfoRule')
    }
  }, [(_vm.model.visitorInfoType === 2) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType === 3) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约30%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType === 4) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约35%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("身份信息")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "VIRName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.name),
      expression: "model.visitorInfoRule.name"
    }],
    attrs: {
      "id": "VIRName",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.name) ? _vm._i(_vm.model.visitorInfoRule.name, null) > -1 : (_vm.model.visitorInfoRule.name)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.name = $$c
        }
      }
    }
  }), _vm._v(" 姓名")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRMobile"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.mobile),
      expression: "model.visitorInfoRule.mobile"
    }],
    attrs: {
      "id": "VIRMobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.mobile) ? _vm._i(_vm.model.visitorInfoRule.mobile, null) > -1 : (_vm.model.visitorInfoRule.mobile)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.mobile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.mobile = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.mobile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.mobile = $$c
        }
      }
    }
  }), _vm._v(" 手机号")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'visitorInfoRule')),
      expression: "validateErrors.has('tab2','visitorInfoRule')"
    }],
    staticClass: "notice",
    class: {
      'error-text-local': _vm.validateErrors.has('tab2', 'visitorInfoRule')
    }
  }, [_vm._v("\n                            （至少选择一项）\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("证件信息")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "VIRredentials"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.credentials),
      expression: "model.visitorInfoRule.credentials"
    }],
    attrs: {
      "id": "VIRredentials",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.credentials) ? _vm._i(_vm.model.visitorInfoRule.credentials, null) > -1 : (_vm.model.visitorInfoRule.credentials)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.credentials,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.credentials = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.credentials = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.credentials = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRPassport"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.passport),
      expression: "model.visitorInfoRule.passport"
    }],
    attrs: {
      "id": "VIRPassport",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.passport) ? _vm._i(_vm.model.visitorInfoRule.passport, null) > -1 : (_vm.model.visitorInfoRule.passport)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.passport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.passport = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.passport = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.passport = $$c
        }
      }
    }
  }), _vm._v(" 护照")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRMtp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.mtp),
      expression: "model.visitorInfoRule.mtp"
    }],
    attrs: {
      "id": "VIRMtp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.mtp) ? _vm._i(_vm.model.visitorInfoRule.mtp, null) > -1 : (_vm.model.visitorInfoRule.mtp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.mtp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.mtp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.mtp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.mtp = $$c
        }
      }
    }
  }), _vm._v(" 台胞证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRHkmlp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.hkmlp),
      expression: "model.visitorInfoRule.hkmlp"
    }],
    attrs: {
      "id": "VIRHkmlp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.hkmlp) ? _vm._i(_vm.model.visitorInfoRule.hkmlp, null) > -1 : (_vm.model.visitorInfoRule.hkmlp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.hkmlp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.hkmlp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.hkmlp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.hkmlp = $$c
        }
      }
    }
  }), _vm._v(" 港澳通行证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRTlp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.tlp),
      expression: "model.visitorInfoRule.tlp"
    }],
    attrs: {
      "id": "VIRTlp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.tlp) ? _vm._i(_vm.model.visitorInfoRule.tlp, null) > -1 : (_vm.model.visitorInfoRule.tlp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.tlp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.tlp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.tlp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.tlp = $$c
        }
      }
    }
  }), _vm._v(" 大陆居民往来台湾通行证")])]), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("\n                            （若勾选多个证件，用户在购买时只需任选一个证件填写）\n                        ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.model.sourceType === 3 && _vm.model.scrAttrs) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "需要线下预约"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "needBookOffline1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.needBookOffline),
      expression: "model.scrAttrs.needBookOffline"
    }],
    attrs: {
      "id": "needBookOffline1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.scrAttrs.needBookOffline, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.scrAttrs.needBookOffline = false
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needBookOffline2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.needBookOffline),
      expression: "model.scrAttrs.needBookOffline"
    }],
    attrs: {
      "id": "needBookOffline2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.scrAttrs.needBookOffline, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.scrAttrs.needBookOffline = true
      }
    }
  }), _vm._v(" 需要")])]), _vm._v(" "), (_vm.model.scrAttrs.needBookOffline) ? _c('div', {
    staticClass: "extra-content-block"
  }, [_c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes1",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 1) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 需要短信预约\n                        ，请至少提前"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsAheadTime),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsAheadTime = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsAheadTime"
    }
  }), _vm._v("将出行人"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsUserInfo),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsUserInfo = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsUserInfo"
    }
  }), _vm._v("发送至"), _c('v-input', {
    staticClass: "middle-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsPhone),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsPhone = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsPhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 2) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 需要电话预约\n                        ，请至少提前"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.telAheadTime),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.telAheadTime = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.telAheadTime"
    }
  }), _vm._v("拨打"), _c('v-input', {
    staticClass: "middle-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.telPhone),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.telPhone = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.telPhone"
    }
  }), _vm._v("进行预约")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes3",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 4) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 其他\n                        "), _c('v-input', {
    staticClass: "large-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.other),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.other = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.other"
    }
  })], 1)])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "预订数量限制"
    }
  }, [_c('span', [_vm._v("每笔订单最少购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.model.minBuyCount),
      callback: function($$v) {
        _vm.model.minBuyCount = $$v
      },
      expression: "model.minBuyCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("张，最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.maxBuyCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle
    },
    model: {
      value: (_vm.model.maxBuyCount),
      callback: function($$v) {
        _vm.model.maxBuyCount = $$v
      },
      expression: "model.maxBuyCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("张")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.maxBuyCount')),
      expression: "validateErrors.has('tab2', 'model.maxBuyCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("最多预订数量需为正整数，不填为不限")])]), _vm._v(" "), ((_vm.model.contractInfoType === 2 && _vm.model.contractInfoRule.mobile) || (_vm.model.visitorInfoRule.mobile && _vm.model.visitorInfoType != 1)) ? _c('content-block', {
    attrs: {
      "title": "手机号限制"
    }
  }, [_c('span', [_vm._v("同一手机号在")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.isTuan,
      "min": 1
    },
    model: {
      value: (_vm.model.phoneLimitDays),
      callback: function($$v) {
        _vm.model.phoneLimitDays = $$v
      },
      expression: "model.phoneLimitDays"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("天内最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.phoneLimitCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle,
      "change": _vm.limitCheck
    },
    model: {
      value: (_vm.model.phoneLimitCount),
      callback: function($$v) {
        _vm.model.phoneLimitCount = $$v
      },
      expression: "model.phoneLimitCount"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.isTuan,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.phoneLimitUnitType),
      callback: function($$v) {
        _vm.model.phoneLimitUnitType = $$v
      },
      expression: "model.phoneLimitUnitType"
    }
  }, _vm._l((_vm.buyCountLimitTypes), function(item, index) {
    return _c('v-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.phoneLimitCount')),
      expression: "validateErrors.has('tab2', 'model.phoneLimitCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请输入正确的张数")])], 1) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType !== 1 && _vm.model.visitorInfoRule.credentials) ? _c('content-block', {
    attrs: {
      "title": "身份证限制"
    }
  }, [_c('span', [_vm._v("同一身份证在")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.isTuan,
      "min": 1
    },
    model: {
      value: (_vm.model.idLimitDays),
      callback: function($$v) {
        _vm.model.idLimitDays = $$v
      },
      expression: "model.idLimitDays"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("天内最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.idLimitCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle,
      "change": _vm.limitCheck
    },
    model: {
      value: (_vm.model.idLimitCount),
      callback: function($$v) {
        _vm.model.idLimitCount = $$v
      },
      expression: "model.idLimitCount"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.isTuan,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.idLimitUnitType),
      callback: function($$v) {
        _vm.model.idLimitUnitType = $$v
      },
      expression: "model.idLimitUnitType"
    }
  }, _vm._l((_vm.buyCountLimitTypes), function(item, index) {
    return _c('v-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.idLimitCount')),
      expression: "validateErrors.has('tab2', 'model.idLimitCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请输入正确的张数")])], 1) : _vm._e(), _vm._v(" "), (_vm.buyLimitShow) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "限购方式"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.limitDayType),
      expression: "model.limitDayType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.model.limitDayType, 0)
    },
    on: {
      "__c": function($event) {
        _vm.model.limitDayType = 0
      }
    }
  }), _vm._v(" 下单日限购")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.limitDayType),
      expression: "model.limitDayType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.limitDayType, 1)
    },
    on: {
      "__c": function($event) {
        _vm.model.limitDayType = 1
      }
    }
  }), _vm._v(" 游玩日限购")]), _vm._v(" "), _c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("有效期模式的产品不能选择游玩日限购")])]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "订单取消时间"
    }
  }, [_c('span', [_vm._v("下单成功后")]), _vm._v(" "), _c('v-select', {
    staticClass: "mini-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.orderCancelTime),
      callback: function($$v) {
        _vm.model.orderCancelTime = $$v
      },
      expression: "model.orderCancelTime"
    }
  }, _vm._l((_vm.CANCEL_MINUTE), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("分钟内如未付款，系统将自动取消订单")])], 1)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("入园方式")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "出票方式"
    }
  }, [(!_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM1",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.generateTicketMethod, 1)
    },
    on: {
      "change": _vm.changeGenerateTicketMethod,
      "__c": function($event) {
        _vm.model.generateTicketMethod = 1
      }
    }
  }), _vm._v(" 美团出票")]) : _vm._e(), _vm._v(" "), (!_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM2",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.generateTicketMethod, 2)
    },
    on: {
      "change": _vm.changeGenerateTicketMethod,
      "__c": function($event) {
        _vm.model.generateTicketMethod = 2
      }
    }
  }), _vm._v(" 商家手工出票")]) : _vm._e(), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM3",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.generateTicketMethod, 3)
    },
    on: {
      "__c": function($event) {
        _vm.model.generateTicketMethod = 3
      }
    }
  }), _vm._v(" 商家对接出票")]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && _vm.extra.isBD) ? _c('div', {
    staticClass: "block-waring"
  }, [_vm._v("\n                此流程是新方案，未解决需换票的二次预约的产品，请确保已经过培训并培训商家后再选择此项。直签BD咨询刘策（liuce），三方BD咨询刘策（liuce），"), _c('a', {
    attrs: {
      "href": "https://wiki.sankuai.com/pages/viewpage.action?pageId=569306927"
    }
  }, [_vm._v("使用说明")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && !_vm.extra.isBD) ? _c('div', {
    staticClass: "block-waring"
  }, [_vm._v("\n                此流程是新方案，为解决需换票的二次预约产品，请确保您已经过培训，点击下载"), _c('a', {
    attrs: {
      "href": "https://awp-assets.meituan.net/HFE/hotel-fe-notp/assets/files/%E3%80%90%E8%BF%90%E8%90%A5%E6%96%87%E6%A1%A3%E3%80%91%E6%89%8B%E5%B7%A5%E5%87%BA%E7%A5%A8%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%EF%BC%88%E5%95%86%E5%AE%B6%E7%89%88%EF%BC%89V1-20170823.docx"
    }
  }, [_vm._v("使用说明")])]) : _vm._e()]), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "出票时间"
    }
  }, [_vm._v("\n            从\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.startWorkHour),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.startWorkHour = $$v
      },
      expression: "model.generateTicketWorkTime.startWorkHour"
    }
  }, _vm._l((10), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("\n            点\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.startWorkMinute),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.startWorkMinute = $$v
      },
      expression: "model.generateTicketWorkTime.startWorkMinute"
    }
  }, _vm._l((4), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": (n - 1) * 15,
        "value": (n - 1) * 15
      }
    })
  })), _vm._v("\n            分到\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.endWorkHour),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.endWorkHour = $$v
      },
      expression: "model.generateTicketWorkTime.endWorkHour"
    }
  }, _vm._l((6), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n + 17,
        "value": n + 17
      }
    })
  })), _vm._v("\n            点\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.endWorkMinute),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.endWorkMinute = $$v
      },
      expression: "model.generateTicketWorkTime.endWorkMinute"
    }
  }, _vm._l((4), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": (n - 1) * 15,
        "value": (n - 1) * 15
      }
    })
  })), _vm._v("\n            分产生的订单，"), _c('span', {
    staticClass: "red-span"
  }, [_vm._v("30分钟")]), _vm._v("内出票，其他时间的订单，次日\n            "), _c('span', {
    staticClass: "red-span"
  }, [_vm._v("\n                " + _vm._s(_vm.model.generateTicketWorkTime.startWorkMinute + 30 >= 60 ? ((_vm.model.generateTicketWorkTime.startWorkHour+1) + "点" + (_vm.model.generateTicketWorkTime.startWorkMinute-30) + "分") : ((_vm.model.generateTicketWorkTime.startWorkHour) + "点" + (_vm.model.generateTicketWorkTime.startWorkMinute+30) + "分")) + "\n                ")]), _vm._v("出票\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 3) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "下单时是否回传凭证"
    }
  }, [_c('label', {
    attrs: {
      "for": "RV1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.returnVoucher),
      expression: "model.returnVoucher"
    }],
    attrs: {
      "id": "RV1",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.returnVoucher, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.returnVoucher = true
      }
    }
  }), _vm._v(" 是")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "RV2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.returnVoucher),
      expression: "model.returnVoucher"
    }],
    attrs: {
      "id": "RV2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.returnVoucher, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.returnVoucher = false
      }
    }
  }), _vm._v(" 否")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 3 && !_vm.model.returnVoucher) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "用户获取凭证方式说明"
    }
  }, [_c('div', [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.voucherText')
    },
    attrs: {
      "type": "text",
      "maxlength": 50,
      "name": "voucherText",
      "placeholder": "建议填写内容：“凭商家短信入园”、“凭商家二维码验证”"
    },
    model: {
      value: (_vm.model.voucherText),
      callback: function($$v) {
        _vm.model.voucherText = $$v
      },
      expression: "model.voucherText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.voucherText.length) + "/50字")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.voucherText')),
      expression: "validateErrors.has('tab2', 'model.voucherText')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写用户获取凭证方式说明")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 此处内容用于在订单详情页告知用户凭证信息，请根据商家实际情况谨慎填写\n            ")])]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly && !isTuan'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园方式"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('label', {
    attrs: {
      "for": "needTicket1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needTicket),
      expression: "model.needTicket"
    }],
    attrs: {
      "id": "needTicket1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.needTicket, false)
    },
    on: {
      "change": _vm.needTicketChanged,
      "__c": function($event) {
        _vm.model.needTicket = false
      }
    }
  }), _vm._v(" 无需换票，直接验证入园")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needTicket2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needTicket),
      expression: "model.needTicket"
    }],
    attrs: {
      "id": "needTicket2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.needTicket, true)
    },
    on: {
      "change": _vm.needTicketChanged,
      "__c": function($event) {
        _vm.model.needTicket = true
      }
    }
  }), _vm._v(" 换票入园")]), (_vm.model.needTicket) ? _c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选“无需换票，直接验证入园”模式，订单量可增加约20%")]) : _vm._e()]), _vm._v(" "), (_vm.model.needTicket) ? _c('div', {
    staticClass: "extra-content-block"
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票凭证"
    }
  }, [(_vm.model.generateTicketMethod == 3) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 4) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 2) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 5) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 二维码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR5",
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 7) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家订单号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR6",
      "type": "checkbox"
    },
    domProps: {
      "value": 3,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 3) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 3,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家邮件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR7"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR7",
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 8) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR8",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 4) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 2) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 1) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTRMT"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTRMT",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 1) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 美团电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.getTicketRule.needCertificateSupplement) ? _c('div', {
    staticClass: "extra-info-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')
    },
    attrs: {
      "placeholder": "如学生证信息",
      "maxlength": 30
    },
    model: {
      value: (_vm.model.getTicketRule.certificateSupplement),
      callback: function($$v) {
        _vm.model.getTicketRule.certificateSupplement = $$v
      },
      expression: "model.getTicketRule.certificateSupplement"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.getTicketRule.certificateSupplement ? _vm.model.getTicketRule.certificateSupplement.length : 0) + "/30字")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')"
    }],
    staticClass: "help float-help is-danger"
  }, [_vm._v("补充信息不能为空")])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票时间"
    }
  }, [_vm._l((_vm.model.voucherTimes), function(vTime, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px",
        "position": "relative"
      }
    }, [(_vm.model.voucherTimes.length > 1) ? _c('span', {
      staticClass: "ticket-step ticket-step-active",
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v("\n                         从\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v("\n                        分到\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'VTNV' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vTime.needVoucherOrGetInTimeSupplement),
        expression: "vTime.needVoucherOrGetInTimeSupplement"
      }],
      attrs: {
        "id": 'VTNV' + index,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(vTime.needVoucherOrGetInTimeSupplement) ? _vm._i(vTime.needVoucherOrGetInTimeSupplement, null) > -1 : (vTime.needVoucherOrGetInTimeSupplement)
      },
      on: {
        "__c": function($event) {
          var $$a = vTime.needVoucherOrGetInTimeSupplement,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (vTime.needVoucherOrGetInTimeSupplement = $$a.concat($$v))
            } else {
              $$i > -1 && (vTime.needVoucherOrGetInTimeSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            vTime.needVoucherOrGetInTimeSupplement = $$c
          }
        }
      }
    }), _vm._v(" 补充信息")]), _vm._v(" "), (_vm.mode != 'readonly' && _vm.model.voucherTimes.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneVoucherTime(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.voucherTimes.length < 3 && index === _vm.model.voucherTimes.length - 1) ? _c('div', {
      staticClass: "icon-button icon-plus-circle",
      on: {
        "click": _vm.addOneVoucherTime
      }
    }) : _vm._e(), _vm._v(" "), (vTime.needVoucherOrGetInTimeSupplement) ? _c('div', {
      staticClass: "extra-info-input"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)
      },
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "data-key": index,
        "placeholder": "淡旺季信息，淡旺季时间等",
        "maxlength": 30
      },
      model: {
        value: (vTime.voucherOrGetInTimeSupplement),
        callback: function($$v) {
          vTime.voucherOrGetInTimeSupplement = $$v
        },
        expression: "vTime.voucherOrGetInTimeSupplement"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(vTime.voucherOrGetInTimeSupplement.length) + "/30字")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)),
        expression: "validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)"
      }],
      staticClass: "help is-danger",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_vm._v("勾选后，补充信息必填")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', [_c('span', {
    staticClass: "icon-error orange-notice"
  }), _vm._v(" 设置的换票时间要覆盖该产品所有的可用日期")]) : _vm._e()], 2), _vm._v(" "), (_vm.model.needTicket) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票地址"
    }
  }, [_vm._l((_vm.model.ticketGetAddress), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row extra-info-input"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.ticketGetAddress[index]', null, index)
      },
      attrs: {
        "data-key": index,
        "id": "ticketGetAddress",
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 50
      },
      on: {
        "change": function($event) {
          _vm.ticketGetAddressChanged(index)
        }
      },
      model: {
        value: (_vm.model.ticketGetAddress[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.ticketGetAddress, index, $$v)
        },
        expression: "model.ticketGetAddress[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.ticketGetAddress[index].length) + "/50字")])], 1), _vm._v(" "), (_vm.model.ticketGetAddress.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteTicketGetAddress(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'model.ticketGetAddress[index]', null, index)),
        expression: "validateErrors.has('tab2','model.ticketGetAddress[index]', null,index)"
      }],
      staticClass: "help float-help is-danger",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_vm._v("换票地址不能为空")])])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newTicketGetAddress
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增换票地址")])]) : _vm._e()], 2) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "extra-content-block"
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园凭证"
    }
  }, [(_vm.model.generateTicketMethod == 3) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 4) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 2) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 5) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 二维码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR5",
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 7) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家订单号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR6",
      "type": "checkbox"
    },
    domProps: {
      "value": 3,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 3) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 3,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家邮件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR7"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR7",
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 8) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR8",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 4) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 2) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 1) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTRMT"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTRMT",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 1) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 美团电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.getVoucherRule.needCertificateSupplement) ? _c('div', {
    staticClass: "extra-info-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')
    },
    attrs: {
      "placeholder": "如学生证信息",
      "maxlength": 30
    },
    model: {
      value: (_vm.model.getVoucherRule.certificateSupplement),
      callback: function($$v) {
        _vm.model.getVoucherRule.certificateSupplement = $$v
      },
      expression: "model.getVoucherRule.certificateSupplement"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.getVoucherRule.certificateSupplement ? _vm.model.getVoucherRule.certificateSupplement.length : 0) + "/30字")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("补充信息不能为空")])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园时间"
    }
  }, [_vm._l((_vm.model.voucherTimes), function(vTime, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px",
        "position": "relative"
      }
    }, [(_vm.model.voucherTimes.length > 1) ? _c('span', {
      staticClass: "ticket-step ticket-step-active",
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v("\n                         从\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v("\n                        分到\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'VTNV' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vTime.needVoucherOrGetInTimeSupplement),
        expression: "vTime.needVoucherOrGetInTimeSupplement"
      }],
      attrs: {
        "id": 'VTNV' + index,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(vTime.needVoucherOrGetInTimeSupplement) ? _vm._i(vTime.needVoucherOrGetInTimeSupplement, null) > -1 : (vTime.needVoucherOrGetInTimeSupplement)
      },
      on: {
        "__c": function($event) {
          var $$a = vTime.needVoucherOrGetInTimeSupplement,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (vTime.needVoucherOrGetInTimeSupplement = $$a.concat($$v))
            } else {
              $$i > -1 && (vTime.needVoucherOrGetInTimeSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            vTime.needVoucherOrGetInTimeSupplement = $$c
          }
        }
      }
    }), _vm._v(" 补充信息")]), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneVoucherTime(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.voucherTimes.length < 3 && index === _vm.model.voucherTimes.length - 1) ? _c('div', {
      staticClass: "icon-button icon-plus-circle",
      on: {
        "click": _vm.addOneVoucherTime
      }
    }) : _vm._e(), _vm._v(" "), (vTime.needVoucherOrGetInTimeSupplement) ? _c('div', {
      staticClass: "extra-info-input"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)
      },
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "data-key": index,
        "placeholder": "淡旺季信息，淡旺季时间等",
        "maxlength": 30
      },
      model: {
        value: (vTime.voucherOrGetInTimeSupplement),
        callback: function($$v) {
          vTime.voucherOrGetInTimeSupplement = $$v
        },
        expression: "vTime.voucherOrGetInTimeSupplement"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(vTime.voucherOrGetInTimeSupplement.length) + "/30字")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)),
        expression: "validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)"
      }],
      staticClass: "help is-danger",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_vm._v("勾选后，补充信息必填")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', [_c('span', {
    staticClass: "icon-error orange-notice"
  }), _vm._v(" 设置的入园时间要覆盖该产品所有的可用日期")]) : _vm._e()], 2), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "入园地址",
      "isRequired": ""
    }
  }, [_vm._l((_vm.model.getInAddresses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "position": "relative",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getInAddresses[index]', null, index)
      },
      attrs: {
        "data-key": index,
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 50
      },
      model: {
        value: (_vm.model.getInAddresses[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.getInAddresses, index, $$v)
        },
        expression: "model.getInAddresses[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.getInAddresses[index].length) + "/50字")])], 1), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.getInAddresses.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteGetInAddresses(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'model.getInAddresses[index]', null, index)),
        expression: "validateErrors.has('tab2','model.getInAddresses[index]', null,index)"
      }],
      staticClass: "help float-help is-danger",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_vm._v("入园地址不能为空")])])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newGetInAddresses
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增入园地址")])]) : _vm._e()], 2)], 1)], 1)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.model.needTicket) ? _c('content-block', {
    attrs: {
      "title": "入园地址"
    }
  }, [_vm._l((_vm.model.getInAddresses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "position": "relative",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-sm-11"
    }, [_c('v-input', {
      staticStyle: {
        "padding-right": "55px"
      },
      attrs: {
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 80
      },
      model: {
        value: (_vm.model.getInAddresses[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.getInAddresses, index, $$v)
        },
        expression: "model.getInAddresses[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.getInAddresses[index].length) + "/80字")])], 1), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.getInAddresses.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteGetInAddresses(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newGetInAddresses
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增入园地址")])]) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "其他说明"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 1000,
      "placeholder": "选填，已在其他栏填写过的信息请勿重复填写，否则产品可能被审核人员驳回"
    },
    model: {
      value: (_vm.model.otherNote),
      callback: function($$v) {
        _vm.model.otherNote = $$v
      },
      expression: "model.otherNote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.otherNote.length > 1000 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.otherNote.length) + "/1000字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  })], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11bf0cee","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Instruction.vue
// module id = 499
// module chunks = 0